import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * 페이지 이동 시 화면을 맨 위로 올린다.
 *
 * 배경(다니엘 지적 2026-07-30): 대시보드 중간에서 카드를 눌러 다른 페이지로 가면
 * 스크롤 위치가 그대로 남아 새 페이지가 중간부터 보였다. 이 앱에는 전역 스크롤
 * 초기화가 없어 모든 라우트 전환에서 같은 문제가 있었다.
 *
 * 뒤로가기·앞으로가기(POP)는 예외 — 유저가 보던 위치로 돌아가는 게 맞다.
 * Router 안, Routes 앞에 한 번만 둔다.
 */
const ScrollToTop = (): null => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType === 'POP') return;
        // 'auto'는 CSS scroll-behavior(globals.css에서 html{smooth})를 따라가 애니메이션이 된다.
        // 그 사이 손가락을 대면 애니메이션이 취소돼 새 페이지 중간에 멈춘다 — 'instant'로 즉시 이동.
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    }, [pathname, navigationType]);

    return null;
};

export default ScrollToTop;
